import { render, staticRenderFns } from "./addModelNew.vue?vue&type=template&id=0ff36dcf&scoped=true&"
import script from "./addModelNew.vue?vue&type=script&lang=js&"
export * from "./addModelNew.vue?vue&type=script&lang=js&"
import style0 from "./addModelNew.vue?vue&type=style&index=0&id=0ff36dcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff36dcf",
  null
  
)

export default component.exports